import * as React from 'react'
import { Column, ColumnOption } from '../types'
import DropdownOptionsEditor from '../dropdown_options_editor'
import I18n from '../../../../libs/i18n'

interface SelectSettingsProps {
  column: Column
  onUpdate: (updates: Partial<Column>) => void
  generateOptionId: () => string
}

export default function SelectSettings({
  column,
  onUpdate,
  generateOptionId,
}: SelectSettingsProps) {
  const options = column.column_options || []
  const allowMultiselect = column.settings?.allow_multiselect === true ||
    column.settings?.allow_multiselect === 'true'

  const handleOptionsChange = (newOptions: ColumnOption[]) => {
    onUpdate({ column_options: newOptions })
  }

  return (
    <div>
      <div className="form-check mb-2">
        <input
          type="checkbox"
          className="form-check-input"
          id={`allow-multiselect-${column.id}`}
          checked={allowMultiselect}
          onChange={(e) =>
            onUpdate({
              settings: { ...column.settings, allow_multiselect: e.target.checked },
            })
          }
        />
        <label className="form-check-label small" htmlFor={`allow-multiselect-${column.id}`}>
          {I18n.t('project_groups.columns_editor.allow_multiselect')}
        </label>
      </div>
      <DropdownOptionsEditor
        options={options}
        onChange={handleOptionsChange}
        generateOptionId={generateOptionId}
      />
    </div>
  )
}
